import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {classToPlain, plainToClass, Type} from 'class-transformer';
import {ConfirmationService, SelectItem} from "primeng/api";
import {PubNubAngular} from 'pubnub-angular2';
import {forkJoin, Subscription} from 'rxjs';

import {CommonDataService, CommonTransformationService, DialogStyle40, PubNubStatusCategory, UserInfo} from "@app/shared";
import {GrowlService} from 'app/core/growl/growl.service';
import {UserService} from 'app/core/user/user.service';
import {ConnectService} from 'app/core/connect/connect.service';
import {SysParam} from '@app/shared/enums/sys-param.enum';
import {Validation} from "@app/shared/enums/validation.enum";

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.css'],
  providers: [ConnectService, ConfirmationService, PubNubAngular]
})
export class ConnectComponent implements OnInit, OnDestroy {

  DialogStyle40 = DialogStyle40;
  Validation: typeof Validation = Validation;

  display23: boolean = false;
  display24: boolean = false;
  display25: boolean = false;
  display26: boolean = false;

  names: Subscription;
  zoomcall: Subscription;
  contactsSubscription: Subscription;
  updateChannelMemberSubscription: Subscription;
  updateChannelSubscription: Subscription;
  groupSubscription: Subscription;
  addMemberSubscription: Subscription;
  postContactSubscription: Subscription;
  deleteChannelSubscription: Subscription;
  requestSubscription: Subscription;
  lastLogOutTimeSubscription: Subscription;

  channel: Channel = {name: 'dummy'};
  videoCallObject: VideoCall = {joinUrl: '', visible: false, from: '', callType: '', callMode: ''};
  searchResults: UserInfo[];
  globalContext = {display: false};
  friend: UserInfo;
  chatList: Message[] = [];
  newGroupMembers: UserInfo[] = [];
  newGroupMember: UserInfo;
  newGroupName: string = '';
  subscriptionList: string[] = [];
  msg: string;
  ifInList = false;
  contacts: Contact[] = [];
  contacts1: InputChannel[] = [];
  groupsDropDown: SelectItem[];
  selectedGroupInfo: InputChannel;
  selectedGroup: InputChannel;
  groups: InputChannel[] = [];
  groupRequestList: Request[] = [];
  requestsList: Request[] = [];
  sentList: Request[] = [];
  userClicked: string;
  reqListCombined: Request[] = [];
  joinURL: string = 'dummy';
  startURL: string = 'dummy';
  groupRequestSendList: number[] = [];
  deletedGroupMembers: ChannelMembers[] = [];
  requestHelpNumber: number = 0;

  lastLogOutTime: number;
  globalDisplay: boolean = false;


  showHomePage: boolean = false;
  showChatAppearPage: boolean = false;
  showGroupAddAppearPage: boolean = false;
  showGroupInfoAppearPage: boolean = false;
  showGroupUpdatePage: boolean = false;
  requestDiv: boolean = false;

  // user: UserService;
  sub: Subscription;

  // pubNubPublishKey: string;
  // pubNubSubscribeKey: string;

  @Input()
  set displayDialog(value: boolean) {
    if (value) {

      this.globalContext.display = value;
      this.makePagesVisible(Visibility.Home);
    } else {
    }
  }

  @Output() handler: EventEmitter<any> = new EventEmitter();
  @Output() notificationHandler: EventEmitter<any> = new EventEmitter();

  x: number = 0;

  //Connect Initiation Methods

  constructor(public user: UserService,
              private http: HttpClient, private pubnub: PubNubAngular, private connectService: ConnectService, private growl: GrowlService, private commonTransService: CommonTransformationService,
              private confirmationService: ConfirmationService, private commonDataService: CommonDataService) {
    // this.user = user;


    this.sub = UserService.userInfoObs.subscribe(auth => {
      if (auth) {
        this.initiateConnect();
        this.globalDisplay = true;

      }
    });

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.contacts.length = 0;
    this.reqListCombined.length = 0;
    this.sub.unsubscribe();
    this.pubnub.unsubscribeAll();
  }

  //Initates the connect , i.e formats channels, initialises subscription
  initiateConnect() {


    forkJoin( //this.commonDataService.getEnum(EnumNames.revenueTypes)
      [this.commonDataService.getSysParams(SysParam.ConnectPubNubPublishKey), this.commonDataService.getSysParams(SysParam.ConnectPubNubSubscribeKey)])
      .subscribe(res => {
        const pubNubPublishKey = res[0].value;
        const pubNubSubscribeKey = res[1].value;
        this.pubnub.init({
          publishKey: pubNubPublishKey,
          subscribeKey: pubNubSubscribeKey,
        });
      });

    this.lastLogOutTimeSubscription = this.commonDataService.getLastLogForSelf('LOGOUT').subscribe(res => {

      this.lastLogOutTime = (new Date(res).getTime()) / 1000; // conversion yields a 13 digit epoch , so to convert it to standard 10 digit epoch /1000
    });

    this.selectedGroup = {id: null, channelMembers: [], channelName: '', ownerId: null, channelType: 'Group', channelStatus: 'Pending'};
    this.selectedGroupInfo = {id: null};

    this.contacts = [];
    this.contacts1 = [];
    this.contactsSubscription = this.connectService.getContacts('Direct').subscribe(contacts => {

      this.contacts1 = contacts['list'];
      for (let contact of this.contacts1) {
        let addContact: Contact = {userName: '', userId: null, channel: '', contactChannelId: null, id: null};
        addContact.channel = contact.channelName;

        this.returnHistoryCount(addContact);
        // Update the count in the backend
        this.subscriptionList.push(contact.channelName);
        let memberIndex = contact.channelMembers.findIndex(member => member.userId != this.user.info.userId);
        if (memberIndex > -1) {
          if (addContact.unReadMessagesCount > 0) {
            contact.channelMembers[memberIndex].unReadMessagesCount += addContact.unReadMessagesCount;
            this.connectService.updateChannelMember(contact.channelMembers[memberIndex]).subscribe(res => {
              addContact = plainToClass(Contact, res as Contact);
              addContact.channel = contact.channelName;
              this.contacts.push(addContact);
            });
          } else {
            addContact.userName = contact.channelMembers[memberIndex].userName;
            addContact.userId = contact.channelMembers[memberIndex].userId;
            addContact.id = contact.channelMembers[memberIndex].id;
            // addContact.version = contact.channelMembers[memberIndex].version;
            addContact.contactChannelId = contact.channelMembers[memberIndex].contactChannelId;
            addContact.unReadMessagesCount = contact.channelMembers[memberIndex].unReadMessagesCount;
            addContact.acceptStatus = contact.channelMembers[memberIndex].acceptStatus;
            this.contacts.push(addContact);
          }
        }

      }


      this.groupSubscription = this.connectService.getContacts('Group').subscribe(groups => {
        this.groups = groups['list'];

        for (let group of this.groups) {
          this.subscriptionList.push(group.channelName);
        }
        if (this.user && this.user.info && this.user.info.userId) {
          this.subscriptionList.push(this.user.info.userId.toString());
        }

        this.initiateChat(this.chatList, this.channel, this.requestsList, this.sentList, this.reqListCombined, this.groupRequestList,
          this.videoCallObject, this.user, this.groups, this.connectService, new Subscription(), this.growl, this.contacts, this.globalContext, this.notificationHandler);
      });


    });


    let loggedInUserIndex: number;
    let otherUserIndex: number;


    this.requestSubscription = this.connectService.getRequests('Direct').subscribe(res => {
      for (let channel of res['list']) {
        let i = 0;
        for (let member of channel['channelMembers']) {
          if (member['userId'] === this.user.info.userId) {
            loggedInUserIndex = i;
          } else {
            otherUserIndex = i;
          }
          i++;
          if (member['acceptStatus'] == 'Accepted') {
            this.requestHelpNumber += 2;
          }
          if (member['acceptStatus'] == 'Pending') {
            this.requestHelpNumber += 1;
          }
          if (member['acceptStatus'] == 'Rejected') {
            this.requestHelpNumber += 3;
          }
        }
        if (this.user.info.userId == channel['ownerId']) {
          if (this.requestHelpNumber == 2) {
            const sentRequest = {
              'type': 'sent',
              'from': this.user.info.fullName,
              'fromUid': this.user.info.userId.toString(),
              'to': channel['channelMembers'][otherUserIndex]['userName'],
              'toUid': channel['channelMembers'][otherUserIndex]['userId'],
              'channel': channel['channelName'],
              'status': 'Pending',
              'channelId': channel['id'],
              'myIdInChannel': channel['channelMembers'][loggedInUserIndex]['id'],
              'requestedUserIdInChannel': channel['channelMembers'][otherUserIndex]['id']
            };
            this.reqListCombined.unshift(sentRequest);
            this.sentList.unshift(sentRequest);
          }
          if (this.requestHelpNumber == 3) {
            const sentRequest = {
              'type': 'sent',
              'from': this.user.info.fullName,
              'fromUid': this.user.info.userId.toString(),
              'to': channel['channelMembers'][otherUserIndex]['userName'],
              'toUid': channel['channelMembers'][otherUserIndex]['userId'],
              'channel': channel['channelName'],
              'status': 'Add to Contacts',
              'channelId': channel['id'],
              'myIdInChannel': channel['channelMembers'][loggedInUserIndex]['id'],
              'requestedUserIdInChannel': channel['channelMembers'][otherUserIndex]['id']
            };

            this.reqListCombined.unshift(sentRequest);
            this.sentList.unshift(sentRequest);

          }
          if (this.requestHelpNumber == 4) {
            console.log(" user has rejected your request");
          }
        }

        if (this.user.info.userId != channel['ownerId']) {
          if (this.requestHelpNumber == 2) {
            const receivedRequest = {
              'type': 'requestToChat',
              'from': channel['channelMembers'][otherUserIndex]['userName'],
              'fromUid': channel['channelMembers'][otherUserIndex]['userId'],
              'to': this.user.info.fullName,
              'toUid': this.user.info.userId,
              'channel': channel['channelName'],
              'channelId': channel['id'],
              'contactId': channel['channelMembers'][loggedInUserIndex]['id']
            };
            this.requestsList.unshift(receivedRequest);
            const receivedRequestForCombined = Object.assign({}, receivedRequest);
            receivedRequestForCombined['type'] = 'received';
            this.reqListCombined.unshift(receivedRequestForCombined);
          }
        }
        this.requestHelpNumber = 0;
      }
    });

    let ownerIndex: number = null;
    loggedInUserIndex = null;
    this.requestSubscription = this.connectService.getRequests('Group').subscribe(res => {
      for (let channel of res['list']) {
        let i = 0;
        for (let member of channel['channelMembers']) {
          if (member['userId'] === channel['ownerId']) {
            ownerIndex = i;
          }
          if (member['userId'] === this.user.info.userId) {
            loggedInUserIndex = i;
          }
          i++;
        }
        const constructedGroupRequest = {
          'type': 'groupRequest', 'from': channel['channelMembers'][ownerIndex]['userName'], 'fromUid': channel['channelMembers'][ownerIndex]['userId'],
          'to': this.user.info.fullName, 'toUid': this.user.info.userId, 'channel': channel['channelName'], 'channelId': channel['id'], 'contactId': channel['channelMembers'][loggedInUserIndex]['id']
        };
        this.reqListCombined.unshift(constructedGroupRequest);
      }
    });


  }

  returnHistoryCount(addContact: Contact) {
    let fiveMinAgo = ((Date.now()) - (10 * 60 * 1000)) * 10000;
    this.pubnub.history({
      channel: addContact.channel,
      end: this.lastLogOutTime * 10000000, //PubNub needs a 17 digit precision Unix epoch, as per their documentation.
    }).then((response) => {
      addContact.unReadMessagesCount = response['messages'].length;
      if (addContact.unReadMessagesCount > 0) {
        this.notificationHandler.emit(true);
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  makePagesVisible(inputVariable) {
    if (inputVariable == Visibility.Chat) {
      this.showChatAppearPage = true;
      this.showHomePage = false;
      this.showGroupAddAppearPage = false;
      this.showGroupInfoAppearPage = false;
      this.showGroupUpdatePage = false;
    }

    if (inputVariable == Visibility.Home) {
      this.showHomePage = true;
      this.showChatAppearPage = false;
      this.showGroupAddAppearPage = false;
      this.showGroupInfoAppearPage = false;
      this.showGroupUpdatePage = false;
    }

    if (inputVariable == Visibility.GroupAdd) {
      this.showGroupAddAppearPage = true;
      this.showChatAppearPage = false;
      this.showHomePage = false;
      this.showGroupInfoAppearPage = false;
      this.showGroupUpdatePage = false;
    }


    if (inputVariable == Visibility.GroupUpdate) {
      this.showGroupUpdatePage = true;
      this.showGroupAddAppearPage = false;
      this.showChatAppearPage = false;
      this.showHomePage = false;
      this.showGroupInfoAppearPage = false;
    }

    if (inputVariable == Visibility.GroupInfo) {
      this.showGroupInfoAppearPage = true;
      this.showGroupUpdatePage = false;
      this.showGroupAddAppearPage = false;
      this.showChatAppearPage = false;
      this.showHomePage = false;
    }

  }

  //Initates the group management window
  groupUpdateAppear() {
    this.selectedGroup['channelName'] = '';
    this.selectedGroup['channelMembers'] = [];
    this.groupSubscription = this.connectService.getContacts('Group').subscribe(groups => {
      this.groups = groups['list'];

      this.makePagesVisible(Visibility.GroupUpdate);
      this.groupsDropDown = this.commonTransService.convertToDropDown("channelName", this.groups);
      let i = 0;
      this.groupsDropDown.splice(0, 1);

      for (let group of this.groupsDropDown) {
        if (group.value.ownerId != this.user.info.userId) {
          this.groupsDropDown.splice(i, 1);
        }
        i++;
      }
    });
  }

  //Delete the entire group
  deleteGroup() {
    this.confirmationService.confirm({
      message: 'Do you want to delete the group ' + this.selectedGroup['channelName'] + ' . This action can not be reverted',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {
        this.deleteChannelSubscription = this.connectService.deleteChannel(this.selectedGroup['id']).subscribe(res => {
          const msg = this.user.info.fullName + ', deleted the group on' + this.timeNow() + 'This channel is no longer active';
          const constructedMessage: Message = {'message': msg, 'time': this.timeNow(), 'from': this.user.info.fullName, 'type': 'GroupDelete'};
          this.pubnub.publish({channel: this.selectedGroup['channelName'], message: constructedMessage}).then((response) => {
            console.log(response);
          }).catch((error) => {
            console.log(error);
            this.growl.add('error', 'Network error, please contact Support');
          });
          this.groupUpdateAppear();
        });
      },
      reject: () => {
      }
    });
  }

  //To show the group info window
  showGroupInfo(group) {
    this.selectedGroupInfo = group;
    this.makePagesVisible(Visibility.GroupInfo);

  }

  //Add member to an exisiting group
  addMember() {
    let userFound = false;
    for (let member of this.selectedGroup['channelMembers']) {
      if (member['userId'] == this.newGroupMember['id']) {
        userFound = true;
        this.growl.add('warning', 'User already in group');
      }
    }
    if (!userFound) {
      this.selectedGroup['channelMembers'].push({
        userName: this.newGroupMember.fullName,
        id: null,
        userId: this.newGroupMember['id'],
        contactChannelId: +this.selectedGroup['id'],
        acceptStatus: AcceptStatus.pending
      });
      this.groupRequestSendList.push(this.newGroupMember['id']);
    }
    this.newGroupMember = undefined;
  }

  //Persists the updated group
  updateGroup() {

    this.updateChannelSubscription = this.connectService.updateGroup(classToPlain(this.selectedGroup, {excludePrefixes: ['_$visited']})).subscribe(group => {
      for (let entry of this.groupRequestSendList) {
        for (let member of group['channelMembers']) {
          if (member['userId'] == entry) {
            const constructedGroupRequest = {
              'type': 'requestToJoinGroup', 'from': this.user.info.fullName, 'fromUid': this.user.info.userId,
              'to': member['userName'], 'toUid': member['userId'], 'channel': group['channelName'], 'channelId': group.id, 'contactId': member['id']
            };
            this.pubnub.publish({channel: member['userId'], message: constructedGroupRequest}).then((response) => {
              console.log(response);
            }).catch((error) => {
              console.log(error);
              this.growl.add('error', 'Network error, please contact Support');
            });
          }
        }
      }
      for (let deletedMember of this.deletedGroupMembers) {
        const constructedDeleteMemberMessage = {
          type: 'deletedFromGroup', 'from': this.user.info.fullName, 'fromUid': this.user.info.userId,
          'to': deletedMember['userName'], 'toUid': deletedMember['userId'], 'channel': deletedMember['userId'], 'channelName': this.selectedGroup['channelName']
        };
        this.pubnub.publish({channel: deletedMember['userId'].toString(), message: constructedDeleteMemberMessage}).then((response) => {
          console.log(response);
        }).catch((error) => {
          console.log(error);
          this.growl.add('error', 'Network error, please contact Support');
        });

        const msg = this.user.info.fullName + ' Removed ' + deletedMember['userName'] + ' on ' + this.timeNow();
        const constructedMessage: Message = {'message': msg, 'time': this.timeNow(), 'from': this.user.info.fullName, 'type': 'GroupDelete'};

        this.pubnub.publish({channel: this.selectedGroup['channelName'], message: constructedMessage}).then((response) => {
          console.log(response);
        }).catch((error) => {
          console.log(error);
        });
      }
      this.groupUpdateAppear();
    });
  }

  //Delete yourself from a group you belong to
  deleteSelfFromGroup(member) {
    this.confirmationService.confirm({
      message: 'Do you want to leave the group ' + this.selectedGroupInfo.channelName + '. This action can not be reverted',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {
        member['acceptStatus'] = AcceptStatus.rejected;
        this.updateChannelMemberSubscription = this.connectService.updateChannelMember(member).subscribe(res => {
          const msg = member['userName'] + ' has left the group on ' + this.timeNow();
          const constructedMessage: Message = {'message': msg, 'time': this.timeNow(), 'from': this.user.info.fullName, 'type': 'GroupDelete'};
          this.pubnub.publish({channel: this.selectedGroupInfo.channelName, message: constructedMessage}).then((response) => {
            console.log(response);
          }).catch((error) => {
            console.log(error);
          });
          this.groupSubscription = this.connectService.getContacts('Group').subscribe(groups => {
            this.groups = groups['list'];
            this.onBack();
          });
        });
      },
      reject: () => {
      }
    });
  }

  //Delete a member from a group you own
  deleteMember(member) {
    this.confirmationService.confirm({
      message: 'Do you want to delete ' + member.userName + ' from the group.',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {
        this.deletedGroupMembers.push(member);
        this.selectedGroup['channelMembers'].splice(this.selectedGroup['channelMembers'].indexOf(member), 1);
      },
      reject: () => {
      }
    });
  }

  //Events on hide of the connect dialog box
  onHideDialog(event) {
    this.channel.name = '';
    this.handler.emit("closed");

  }

  //Checks if the user is already a contact/ requested else displays the request div
  process() {
    const constructedChannel = this.friend['id'] > this.user.info.userId ? this.user.info.orgId + '_' + this.user.info.userId.toString() + '_'
      + this.friend['id'].toString() : this.user.info.orgId + '_' + this.friend['id'].toString() + '_' + this.user.info.userId.toString();

    this.searchSubscription(constructedChannel);
  }

  //Creates new group
  processNewGroup() {
    let channelName = this.newGroupName + '_' + this.user.info.orgName;

    const time = this.timeNow();
    const msg = this.user.info.fullName + ' Created ' + channelName + ' on ' + time;
    const constructedMessage: Message = {'message': msg, 'time': time, 'from': this.user.info.fullName, 'type': 'GroupAdd'};

    this.postContactSubscription = this.connectService.postContact(this.createNewGroupBody(channelName, this.newGroupMembers)).subscribe(res => {
      this.pubnub.publish({channel: channelName, message: constructedMessage}).then((response) => {
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
      this.groups.push(res);
      this.subscriptionList.push(res['channelName']);
      this.pubnub.subscribe({
        channels: this.subscriptionList
      });

      this.userClicked = channelName;
      this.channel.name = channelName;
      this.chatList.length = 0;

      for (let member of res['channelMembers']) {
        if (member['userId'] != this.user.info.userId) {
          const constructedGroupRequest = {
            'type': 'requestToJoinGroup', 'from': this.user.info.fullName, 'fromUid': this.user.info.userId,
            'to': member['userName'], 'toUid': member['userId'], 'channel': channelName, 'channelId': res.id, 'contactId': member['id']
          };

          this.pubnub.publish({channel: member['userId'], message: constructedGroupRequest}).then((response) => {
            console.log(response);
          }).catch((error) => {
            console.log(error);
            this.growl.add('error', 'Network error, please contact Support');
          });
        }
      }
      this.newGroupName = '';
      this.newGroupMembers.length = 0;

      this.makePagesVisible(Visibility.Chat);

    });

  }

  //Creates new group body to be sent as a payload
  createNewGroupBody(groupName, members) {
    let channelAdd: InputChannel = {id: null};
    let membersList: ChannelMembers[] = [];
    channelAdd.channelName = groupName;
    channelAdd.channelType = "Group";
    channelAdd.ownerId = this.user.info.userId;
    channelAdd.channelStatus = 'Pending';
    channelAdd.version = 0;
    membersList.push({id: null, userId: this.user.info.userId, contactChannelId: null, acceptStatus: AcceptStatus.accepted, unReadMessagesCount: null});

    for (let member of members) {
      membersList.push({id: null, userId: member['id'], contactChannelId: null, acceptStatus: AcceptStatus.pending, unReadMessagesCount: null});
    }
    channelAdd.channelMembers = membersList;

    return channelAdd;
  }

  //Executes changes when a contact chat is clicked
  onSelectChatContact(contact) {
    this.userClicked = contact['userName'];
    this.channel.name = contact['channel'];
    if (contact['unReadMessagesCount'] == 0 || !contact['unReadMessagesCount']) {
    }
    contact['unReadMessagesCount'] = 0;
    this.connectService.updateChannelMember((classToPlain(contact, {excludePrefixes: ['channel']}))).subscribe(res => {
      // contact['version'] = res['version'];
    });
    this.changeData(this.chatList);
  }

  //Does a video call
  onSelectVideoContact(contact, typeOfCall) {

    this.connectService.getZoomVideoURLV2(this.user.info.userId + 'VC' + contact['userId'], this.user.info.workEmail, typeOfCall).subscribe(response => {

      this.joinURL = response['join_url'];
      this.startURL = response['start_url'];
      window.open(this.startURL, "_blank");
      const constructedVideoCallRequest = {
        'type': 'requestToJoinVC', 'from': this.user.info.fullName, 'fromUid': this.user.info.userId,
        'to': contact['userName'], 'toUid': contact['userId'], 'joinURL': this.joinURL, 'callType': typeOfCall, 'callMode': 'single'
      };
      this.pubnub.publish({channel: contact['userId'], message: constructedVideoCallRequest}).then((response) => {
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
    });
  }

  //Group Video call
  onSelectGroupVideo(group, typeOfCall) {

    this.connectService.getZoomVideoURLV2('VC_' + group['channelName'], this.user.info.workEmail, typeOfCall).subscribe(response => {
      this.joinURL = response['join_url'];
      this.startURL = response['start_url'];
      window.open(this.startURL, "_blank");
      const constructedVideoCallRequest = {
        'type': 'requestToJoinVC', 'from': this.user.info.fullName, 'fromUid': this.user.info.userId,
        'to': group['channelName'], 'joinURL': this.joinURL, 'callType': typeOfCall, 'callMode': 'group'
      };
      this.pubnub.publish({channel: group['channelName'], message: constructedVideoCallRequest}).then((response) => {
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
    });
  }

  onSelectMailContact(contact) {
    window.open("mailto:");
  }

  onSelectGroupMail(group) {
    window.open("mailto:");
  }

  //Executes the changes when you attend a video call
  attendCall() {
    window.open(this.videoCallObject.joinUrl, "_blank");
    this.clearVideoCallObject();
  }

  //Executes the changes when you attend a audio call
  rejectCall() {
    this.clearVideoCallObject();
  }

  clearVideoCallObject() {
    this.videoCallObject.joinUrl = '';
    this.videoCallObject.visible = false;
    this.videoCallObject.from = '';
    this.videoCallObject.callType = '';
    this.videoCallObject.callMode = '';
  }

  //Changes when a group chat is clicked
  onSelectGroupChat(group) {
    this.userClicked = group['channelName'];
    this.channel.name = group['channelName'];
    this.changeData(this.chatList);
  }

  //Manages the request the user has sent
  onSelectSent(sent) {
    if (sent['status'] === 'Pending') {
      console.log('Please Wait for the user to accept your chat request');
    }

    if (sent['status'] === 'Add to Contacts') {
      // const member: ChannelMembers = { id: sent['myIdInChannel'], version: 0, userId: this.user.info.userId, contactChannelId: +sent['channelId'], acceptStatus: AcceptStatus.accepted };
      this.connectService.getChannelMember(sent['myIdInChannel']).subscribe(res => {
        res.acceptStatus = AcceptStatus.accepted;
        this.addMemberSubscription = this.connectService.updateChannelMember(res).subscribe(res => {

          this.contacts.push({
            userName: sent['to'],
            userId: sent['toUid'],
            channel: sent['channel'],
            id: sent['requestedUserIdInChannel'],
            contactChannelId: +sent['channelId'],
            acceptStatus: AcceptStatus.accepted
          });
          const senderAddedReceiverToContact = { //So that we can update the sender already added in the receiver side
            'type': MessageType.SenderAddedReceiverToContacts, 'from': this.user.info.fullName, 'fromUid': this.user.info.userId,
            'to': sent['to'], 'toUid': sent['toUid'], channel: sent['channel'], senderUserId: sent['myIdInChannel']
          };
          this.pubnub.publish({channel: sent['channel'], message: senderAddedReceiverToContact}).then((response) => {
            console.log(response);
          }).catch((error) => {
            console.log(error);
          });
          this.subscriptionList.push(sent['channel']);
          this.pubnub.subscribe({
            channels: this.subscriptionList
          });

          let sentIndex = this.sentList.findIndex(sent1 => sent.channel == sent.channel);
          if (sentIndex > -1) {
            this.sentList.splice(sentIndex, 1);
          }
          let reqListIndex = this.reqListCombined.findIndex(forCombined => forCombined.channel == sent.channel);
          if (reqListIndex > -1) {
            this.reqListCombined.splice(reqListIndex, 1);
          }
          this.channel.name = sent['channel'];
          this.userClicked = sent['to'];
          this.changeData(this.chatList);

          this.makePagesVisible(Visibility.Chat);

        });
      });

    }
  }

  //The following methods deals with changes to the windows
  onBack() {
    this.channel.name = '';
    this.makePagesVisible(Visibility.Home);

  }

  onClickAddGroup() {

    this.makePagesVisible(Visibility.GroupAdd);
  }

  //Dynamically changes data when a particular user/contact is clicked
  changeData(chatList) {

    this.makePagesVisible(Visibility.Chat);

    function handleHistory(history) {
      for (const msg of history) {
        chatList.push(msg['entry']);
      }
    }

    this.chatList.length = 0;
    this.pubnub.history({
      channel: this.channel.name,
      reverse: false, // false is the default
      count: 100, // 100 is the default
      stringifiedTimeToken: true // false is the default
    }).then((response) => {
      handleHistory(response['messages']);
    }).catch((error) => {
      console.log(error);
    });
  }

  //Search if a user already exists in the request/contacts
  searchSubscription(constructedChannel) {
    this.ifInList = false;
    for (let subscription of this.subscriptionList) {
      if (subscription == constructedChannel) {
        this.ifInList = true;
      }
    }
    if (this.ifInList) {
      this.userClicked = this.friend.fullName;
      this.channel.name = constructedChannel;
      this.changeData(this.chatList);
    } else {
      this.requestDiv = true;

    }
  }

  //Create the channel string
  createChannel() {
    const constructedChannel = this.friend['id'] > this.user.info.userId ? this.user.info.orgId + '_' + this.user.info.userId.toString() + '_'
      + this.friend['id'].toString() : this.user.info.orgId + '_' + this.friend['id'].toString() + '_' + this.user.info.userId.toString();
    return constructedChannel;
  }

  //Sends the request to the end user
  sendRequest() {
    let channelResponse: InputChannel;
    let ifInSentList = false;
    let requestUserIdInChannel: number;
    let loggedInUserIdInChannel: number;

    if (this.friend.id == this.user.info.userId) {
      ifInSentList = true;
    }
    let channelCheck = this.createChannel();
    for (let req of this.reqListCombined) {
      if (channelCheck == req.channel) {
        ifInSentList = true;
      }
    }


    if (!ifInSentList) {
      const channel = this.createChannel();

      const channelBody = this.createNewChannelBody({userName: this.friend.fullName, userId: this.friend.id, channel: channel});
      this.postContactSubscription = this.connectService.postContact(channelBody).subscribe(res => {
        channelResponse = res;
        for (let member of channelResponse.channelMembers) {
          if (member.userId != this.user.info.userId) {
            requestUserIdInChannel = member.id;
          } else {
            loggedInUserIdInChannel = member.id;
          }
        }

        const constructedMessageForRequest = {
          'type': 'requestToChat', 'from': this.user.info.fullName, 'fromUid': this.user.info.userId,
          'to': this.friend['fullName'], 'toUid': this.friend['id'], 'channel': channel, 'channelId': channelResponse.id, 'contactId': requestUserIdInChannel,
          'senderIdInChannel': loggedInUserIdInChannel
        };
        const sentRequest = {
          'type': 'requestToChat', 'from': this.user.info.fullName, 'fromUid': this.user.info.userId.toString(),
          'to': this.friend['fullName'], 'toUid': this.friend['id'], 'channel': channel, 'status': 'Pending', 'channelId': channelResponse.id.toString(), 'myIdInChannel': loggedInUserIdInChannel,
          'requestedUserIdInChannel': requestUserIdInChannel
        };
        this.sentList.unshift(sentRequest);
        let forCombined = Object.assign({}, sentRequest);
        forCombined['type'] = 'sent';
        this.reqListCombined.unshift(forCombined);
        this.pubnub.publish({channel: this.friend['id'].toString(), message: constructedMessageForRequest}).then((response) => {
          console.log(response);
        }).catch((error) => {
          console.log(error);
        });
      });
    } else {
      this.growl.add('warn', 'User Present in the Request List');
    }
    this.requestDiv = false;

  }

  noRequest() {
    this.requestDiv = false;

  }

  //Accept a request
  acceptRequest(request) {
    let channelResponse: ChannelMembers;

    const channelBody: ChannelMembers = {
      id: request['contactId'],
      userId: this.user.info.userId,
      contactChannelId: request['channelId'],
      acceptStatus: AcceptStatus.accepted,
      unReadMessagesCount: null
    };
    this.updateChannelMemberSubscription = this.connectService.updateChannelMember(channelBody).subscribe(res => {
      this.subscriptionList.push(request['channel']);
      this.pubnub.subscribe({
        channels: this.subscriptionList
      });
      this.contacts.push({
        userName: request['from'],
        userId: request['fromUid'],
        channel: request['channel'],
        id: request['senderIdInChannel'],
        contactChannelId: request['channelId'],
        acceptStatus: AcceptStatus.accepted,
        unReadMessagesCount: 0
      });
      channelResponse = res;

      const constructedMessageForAcceptance = {
        'type': 'chatAcceptance', 'from': this.user.info.fullName,
        'fromUid': this.user.info.userId, 'channel': request['channel'], 'channelId': res.contactChannelId.toString()
      };
      this.pubnub.publish({channel: request['fromUid'], message: constructedMessageForAcceptance}).then((response) => {
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });

      function isSame(req) {
        return request['channelId'] == req['channelId'];
      }

      let reqIndex = this.requestsList.findIndex(isSame);
      if (reqIndex > -1) {
        this.requestsList.splice(reqIndex, 1);
      }
      let forCombined = Object.assign({}, request);
      forCombined['type'] = 'received';
      let reqCombinedIndex = this.reqListCombined.findIndex(isSame);
      if (reqCombinedIndex > -1) {
        this.reqListCombined.splice(reqCombinedIndex, 1);
      }
    });

  }

  //Creates a new channel body to be sent to the backend
  createNewChannelBody(contact: Contact) {
    let channelAdd: InputChannel = {id: null};
    let membersList: ChannelMembers[] = [];
    channelAdd.channelName = contact.channel;
    channelAdd.channelType = "Direct";
    channelAdd.channelStatus = "Pending";
    channelAdd.ownerId = this.user.info.userId;
    channelAdd.version = 0;
    membersList.push({id: null, userId: this.user.info.userId, contactChannelId: null, acceptStatus: AcceptStatus.pending, unReadMessagesCount: null});
    membersList.push({id: null, userId: +contact.userId, contactChannelId: null, acceptStatus: AcceptStatus.pending, unReadMessagesCount: null});
    channelAdd.channelMembers = membersList;

    return channelAdd;
  }

  //Changes that happens when you accept a group request
  acceptGroupRequest(request) {
    const channelBody: ChannelMembers = {id: request['contactId'], userId: this.user.info.userId, contactChannelId: request['channelId'], acceptStatus: AcceptStatus.accepted, unReadMessagesCount: 0};
    this.updateChannelMemberSubscription = this.connectService.updateChannelMember(channelBody).subscribe(res => {

      const time = this.timeNow();
      const msg = this.user.info.fullName + ' Joined ' + this.newGroupName + ' on ' + time;
      const constructedMessage: Message = {'message': msg, 'time': time, 'from': this.user.info.fullName, 'type': 'GroupAdd'};
      this.subscriptionList.push(request['channel']);
      this.pubnub.subscribe({
        channels: this.subscriptionList
      });
      this.pubnub.publish({channel: request['channel'], message: constructedMessage}).then((response) => {
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
      // this.groups.push({ channelName: request['channel'], owner: 'false' });
      this.groupSubscription = this.connectService.getContacts('Group').subscribe(groups => {
        this.groups = groups['list'];
      });
      let forCombinedGroupIndex = this.reqListCombined.indexOf(request);
      if (forCombinedGroupIndex > -1) {
        this.reqListCombined.splice(forCombinedGroupIndex, 1);
      }

      let forGroup = Object.assign({}, request);
      forGroup['type'] = 'requestToJoinGroup';

      let groupReqIndex = this.groupRequestList.findIndex(groupReq => groupReq.channel == forGroup.channel);
      if (groupReqIndex > -1) {
        this.groupRequestList.splice(groupReqIndex, 1);
      }
    });
  }

  // Reject a request
  rejectRequest(request) {

    function isSame(req) {
      return request['channelId'] == req['channelId'];
    }

    this.connectService.deleteChannel(request['channelId']).subscribe(res => {
      let reqIndex = this.requestsList.findIndex(isSame);
      if (reqIndex > -1) {
        this.requestsList.splice(reqIndex, 1);
      }
      let forCombined = Object.assign({}, request);
      forCombined['type'] = 'received';
      let reqCombinedIndex = this.reqListCombined.findIndex(isSame);
      if (reqCombinedIndex > -1) {
        this.reqListCombined.splice(reqCombinedIndex, 1);
      }
    });


  }

  // Reject a group request
  rejectGroupRequest(request) {

    let forCombinedGroupIndex = this.reqListCombined.indexOf(request);
    if (forCombinedGroupIndex > -1) {
      this.reqListCombined.splice(forCombinedGroupIndex, 1);
    }

    let forGroup = Object.assign({}, request);
    forGroup['type'] = 'requestToJoinGroup';

    let groupReqIndex = this.groupRequestList.findIndex(groupReq => groupReq.channel == forGroup.channel);
    if (groupReqIndex > -1) {
      this.groupRequestList.splice(groupReqIndex, 1);
    }
  }

  //Autocomplete search of the list of users
  searchUser(event) {
    this.names = this.commonDataService.searchUserByName(event.query).subscribe(res => {
      this.searchResults = res.list;
    });
  }

  //Current time as string
  timeNow() {
    let d = new Date();
    return d.toString().substring(0, 25);
  }

  //Publishes message to a particular channel
  publish() {
    let time = this.timeNow();
    const constructedMessage: Message = {'message': this.msg, 'time': time, 'from': this.user.info.fullName, 'type': 'Message', 'fromUid': this.user.info.userId};
    this.pubnub.publish({channel: this.channel.name, message: constructedMessage}).then((response) => {
      console.log(response);
    }).catch((error) => {
      console.log(error);
    });
    this.msg = '';
  }

  closeDialog() {
    this.globalContext.display = false;
  }

  //Initiates Pubnub, handles all incoming messages/requests/calls
  initiateChat(chatList: Message[], channel: Channel, requestsList: Request[], sentList: Request[], reqListCombined: Request[], groupRequestList: Request[], videoCallObject: VideoCall,
               user: UserService, groups: InputChannel[], connectService: ConnectService, deleteMemberSubscription: Subscription, growl: GrowlService, contacts: Contact[], globalContext, notificationHandler: EventEmitter<any>) {

    function handleMessage(message) {
      const realMessage = message['message'];
      if (realMessage['type'] == MessageType.requestToChat) {
        requestsList.unshift(realMessage);
        let forCombined = Object.assign({}, realMessage);
        forCombined['type'] = 'received';
        reqListCombined.unshift(forCombined);
      }

      if (realMessage['type'] == MessageType.requestToJoinGroup) {
        groupRequestList.unshift(realMessage);
        let forCombined = Object.assign({}, realMessage);
        forCombined['type'] = 'groupRequest';
        reqListCombined.unshift(forCombined);
      }

      if (realMessage['type'] == MessageType.chatAcceptance) {
        let foundReq: Request;
        let foundReqCombined: Request;
        for (let sent of sentList) {
          if (sent['toUid'] === realMessage['fromUid']) {
            foundReq = sent;
          }
        }
        foundReq['status'] = 'Add to Contacts';
        for (let combinedSent of reqListCombined) {
          if (combinedSent['toUid'] === realMessage['fromUid']) {
            foundReqCombined = combinedSent;
          }
        }
        foundReqCombined['status'] = 'Add to Contacts';
      }

      if (realMessage['type'] == MessageType.message) {

        if (!globalContext.display && user.info.userId.toString() != realMessage['fromUid']) {
          notificationHandler.emit(true);
        }
        if (channel.name === message['channel']) {

          chatList.push(realMessage);
        } else {
          growl.add('info', realMessage['from'] + ': ' + realMessage['message'], true);
          for (let contact of contacts) {
            if (contact['userId'] == realMessage['fromUid'].toString()) {
              contact.unReadMessagesCount = contact.unReadMessagesCount + 1;
              let newContact = Object.assign({}, contact);
              delete newContact['channel'];
              let updateUnreadSubscription: Subscription = connectService.updateChannelMember(newContact).subscribe(res => {
                // contact['version'] = res['version'];
              });
            }
          }
        }
      }

      if ((realMessage['type'] == MessageType.SenderAddedReceiverToContacts)) {
        for (let contact of contacts) {
          if (contact['id'] == realMessage['senderUserId']) {
            connectService.getChannelMember(contact['id']).subscribe(res => {
              // contact['version'] = res['version'];
            });
          }
        }
      }

      if ((realMessage['type'] == MessageType.groupAdd) || (realMessage['type'] == MessageType.groupDelete)) {
        if (channel.name === message['channel']) {
          chatList.push(realMessage);
        } else {
          console.log('message from +' + realMessage['from']);
        }

      }

      if (realMessage['type'] == MessageType.userDeletedFromGroup) {
        deleteMemberSubscription = connectService.getContacts('Group').subscribe(groups1 => {
          groups = groups1['list'];
        });

      }

      if (realMessage['type'] == MessageType.requestToJoinVC) {
        videoCallObject.joinUrl = realMessage['joinURL'];
        videoCallObject.from = realMessage['from'];
        if (user.info.userId.toString() != realMessage['fromUid']) {
          videoCallObject.visible = true;
        }
        videoCallObject.callType = realMessage['callType'];

        if (realMessage['callMode'] == 'group') {
          videoCallObject.from = realMessage['from'] + " in " + realMessage['to'];
        }
      }
    }

    this.pubnub.addListener({
      status: function (statusEvent) {
        if ((statusEvent.category == PubNubStatusCategory.PNNetworkDownCategory) || (statusEvent.category == PubNubStatusCategory.PNNetworkIssuesCategory)) {
          // growl.add(GrowlType.Error, 'Network error, please contact Support');
          return;
        }
      },
      message: function (message) {
        handleMessage(message);
      }
    });
    this.pubnub.subscribe({
      channels: this.subscriptionList,
    });
  }
}

export class Contact {
  id?: number;
  // version?: number;
  userName: string;
  userId: number;
  channel: string;
  unReadMessagesCount?: number;
  contactChannelId?: number;
  acceptStatus?: string;
}

export class Group {
  channelName: string;
  owner: string;
}

export class Channel {
  name: string;
}

export class VideoCall {
  joinUrl: string;
  visible: boolean;
  from: string;
  callType: string;
  callMode: string;
}

export class Message {
  message: string;
  type: string;
  from: string;
  time: string;
  fromUid?: number;
}

export class Request {
  type: string;
  fromUid: string;
  from: string;
  to: string;
  toUid: number;
  channel: string;
  status?: string;
  channelId?: string;
  myIdInChannel?: number;
  contactChannelId?: number;
  contactId?: number;
  requestUserIdInChannel?: number;
}

function getChannelMembersType() {
  return ChannelMembers;
}

export class InputChannel {
  id: number;
  version?: number;
  channelName?: string;
  channelType?: string;
  ownerId?: number;
  @Type(getChannelMembersType) channelMembers?: ChannelMembers[];
  channelStatus?: string;
}

export class ChannelMembers {
  id?: number;
  // version?: number;
  userId?: number;
  contactChannelId?: number;
  unReadMessagesCount?: number;
  userName?: string;
  acceptStatus?: string;
}

export enum MessageType {
  requestToChat = 'requestToChat',
  requestToJoinGroup = 'requestToJoinGroup',
  chatAcceptance = 'chatAcceptance',
  message = 'Message',
  groupAdd = 'GroupAdd',
  groupDelete = 'GroupDelete',
  requestToJoinVC = 'requestToJoinVC',
  userDeletedFromGroup = 'deletedFromGroup',
  SenderAddedReceiverToContacts = 'senderAddedReceiverToContacts'
}

enum Visibility {
  GroupUpdate = "GROUP_UPDATE",
  Home = "HOME",
  Chat = "CHAT",
  GroupInfo = "GROUP_INFO",
  GroupAdd = "GROUP_ADD"

}

export enum AcceptStatus {
  accepted = 'Accepted',
  rejected = 'Rejected',
  pending = 'Pending',
  all = 'All'
}
